module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-sm navbar-light bg-light"
  }, [_c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNav",
      "aria-controls": "navbarNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-toggler-inside"
  }, [_c('span', {
    staticClass: "active-item-on-collapsed-menu"
  }, [(_vm.$router.currentRoute.path == '/services') ? _c('span', [_vm._v("MOJE SLUŽBY")]) : (_vm.$router.currentRoute.path == '/devices') ? _c('span', [_vm._v("MOJE KONCOVÁ ZAŘÍZENÍ")]) : (_vm.$router.currentRoute.path == '/account') ? _c('span', [_vm._v("MŮJ ÚČET")]) : (_vm.$router.currentRoute.path == '/findocs') ? _c('span', [_vm._v("MOJE FAKTURY")]) : (_vm.$router.currentRoute.path == '/personal') ? _c('span', [_vm._v("OSOBNÍ ÚDAJE")]) : (_vm.$router.currentRoute.path == '/referral') ? _c('span', [_vm._v("DOPORUČ & ZÍSKEJ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarNav"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/services"
    }
  }, [_vm._v("MOJE SLUŽBY")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/devices"
    }
  }, [_vm._v("MOJE KONCOVÁ ZAŘÍZENÍ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/account"
    }
  }, [_vm._v("MŮJ ÚČET"), (_vm.nedoplatek) ? _c('span', {
    staticClass: "badge badge-pill badge-danger",
    attrs: {
      "id": "nedoplatek"
    }
  }, [_vm._v("-" + _vm._s(_vm.nedoplatek) + " Kč")]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/findocs"
    }
  }, [_vm._v("MOJE FAKTURY")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/personal"
    }
  }, [_vm._v("OSOBNÍ ÚDAJE")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/referral"
    }
  }, [_vm._v("DOPORUČ & ZÍSKEJ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00512f14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 313
// module chunks = 1 2